import { NavLink, useNavigate } from 'react-router-dom'
import {
  IconLayoutDashboard, IconTicket, IconBuildingStore,
  IconSpeakerphone, IconCash, IconBoltOff, IconRobot, IconLogout, IconClipboardList
} from '@tabler/icons-react'
import '../styles/arboleda.css'

export default function Layout({ children, usuario, onLogout }) {
  const navigate = useNavigate()
  const esDirector = usuario?.rol === 'director'

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('usuario')
    onLogout()
    navigate('/login')
  }

  const initials = usuario?.nombre
    ? usuario.nombre.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
    : 'AD'

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="bracket">[Arboleda]:</div>
          <div className="name">District Cooling System</div>
          <div className="sub">Panel de Administración</div>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/" end className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <IconLayoutDashboard size={17} /> Dashboard
          </NavLink>
          <div className="nav-section">Gestión</div>
          <NavLink to="/tickets" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <IconTicket size={17} /> Tickets
          </NavLink>
          <NavLink to="/residentes" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <IconBuildingStore size={17} /> Residentes
          </NavLink>
          <NavLink to="/comunicados" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <IconSpeakerphone size={17} /> Comunicados
          </NavLink>
          <NavLink to="/solicitudes" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <IconClipboardList size={17} /> Solicitudes
          </NavLink>
          <div className="nav-section">Cobranza</div>
          <NavLink to="/pagos" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <IconCash size={17} /> Pagos
          </NavLink>
          <NavLink to="/cortes" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <IconBoltOff size={17} /> Cortes
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <div className="user-avatar">{initials}</div>
          <div style={{ flex: 1 }}>
            <div className="user-name">{usuario?.nombre || 'Administrador'}</div>
            <div style={{ fontSize: 10, color: '#4A4A42' }}>
              {esDirector ? 'Director' : 'Operador'}
            </div>
          </div>
          <IconLogout size={16} color="#4A4A42" style={{ cursor: 'pointer' }} onClick={handleLogout} />
        </div>
      </aside>

      <div className="main">
        <div className="topbar">
          <div className="topbar-title" style={{ fontFamily: 'Playfair Display, serif' }}>
            District Cooling Arboleda
          </div>
          <div className="topbar-right">
            <div className="ia-pill">
              <IconRobot size={13} /> Agente IA activo
            </div>
          </div>
        </div>
        <div className="page-content">
          {children}
        </div>
      </div>
    </div>
  )
}